/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconHeartBolt = createReactComponent("outline", "heart-bolt", "IconHeartBolt", [["path", { "d": "M13 19l-1 1l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 0 1 8.003 5.997", "key": "svg-0" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-1" }]]);

export { IconHeartBolt as default };
//# sourceMappingURL=IconHeartBolt.mjs.map
